import http from "../api/apiClient";

const normalizeList = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.content)) return data.content;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.data)) return data.data;
  return [];
};

export const fetchWaitingWithClass = async () => {
  const { data } = await http.get("/reports/waiting-with-class");
  return normalizeList(data);
};
